module.exports = __webpack_public_path__ + "img/warning-n.d0e98ac5.svg";